import React from 'react';
import Link from 'gatsby-link';
import config from '../utils/config';
import PageTitle from '../components/PageTitle';

const Schedule = () => (
  <div>
    <PageTitle title="Schedule" />
    <h4
      style={{
        textDecoration: 'underline',
      }}>
      {config.wedding.date}
    </h4>
    <p>
      <strong>
        {config.wedding.startTime + ' - ' + config.wedding.endTime}
      </strong>
      <br />
      <span
        style={{
          fontStyle: 'italic',
        }}>
        Wedding
      </span>
      <br />
      {config.venue.title}
      <br />
      (Please arrive no later than {config.wedding.arrivalTime})
    </p>
  </div>
);

export default Schedule;



// WEBPACK FOOTER //
// ./src/pages/schedule.js